import React from 'react';
import ReactDOM from 'react-dom/client';
import { createBrowserRouter, RouterProvider, Navigate  } from "react-router-dom";
import './general.css';
import Cliente from './Cliente';

const router = createBrowserRouter([
  { path: "/", element: <Cliente /> },
  { path: "*", element: <Navigate to="/" replace /> }
]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);